<!-- <loading [isLoading]="isLoading" isFullSize="true"></loading> -->
<div>
<route-details (onEmitterRouteDetails) ="checkVisibilityDetails()" *ngIf="_isVisibleDetails"></route-details>
<popup-detail-geopos [$isVisiblePopupMap] ="_isVisiblePopUpMap"></popup-detail-geopos>
<route-filter *ngIf="_isVisiblePanel"></route-filter>
<panel-resume-route></panel-resume-route>
<!-- <panel-detail-locations></panel-detail-locations> -->
<!-- <panel-detail-routeSteps></panel-detail-routeSteps> -->
<!-- <basemap-selector></basemap-selector> -->
</div>